import { isNotNull } from './def';

export const getFromLocalStorage = <T>(key: string, defaultValue: T): T => {
  const value = localStorage.getItem(key);

  if (isNotNull(value)) {
    try {
      return JSON.parse(value) as T;
    } catch (error) {
      return defaultValue;
    }
  } else {
    return defaultValue;
  }
};

export const setToLocalStorage = <T>(key: string, value: T) => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.error(error);
  }
};
